// // add by ps
// (() => {
//   const originalFetch = window.fetch;

//   window.fetch = async (...args) => {
//     const response = await originalFetch(...args);

//     try {
//       const request = args[0];
//       const url = typeof request === 'string' ? request : request?.url || '';

//       if (url.includes('/cart/add')) {
//         const clonedResponse = response.clone();

//         if (clonedResponse.ok) {
//           const addResponse = await clonedResponse.json();

//           setTimeout(() => {
//             syncCartDrawer(addResponse);
//           }, 50);
//         }
//       }
//     } catch (error) {
//       console.warn('XB cart sync:', error);
//     }

//     return response;
//   };

//   async function syncCartDrawer(addResponse) {
//     const cartDrawer = document.querySelector('cart-drawer');
//     const cartIcon = document.querySelector('#cart-icon-bubble');

//     if (!cartDrawer) return;

//     try {
//       const response = await fetch(
//         `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`,
//         {
//           headers: {
//             'X-Requested-With': 'XMLHttpRequest',
//           },
//         }
//       );

//       if (!response.ok) return;

//       const sections = await response.json();

//       // Update cart drawer content.
//       const drawerElement = document.querySelector('#CartDrawer');

//       if (drawerElement && sections['cart-drawer']) {
//         const parsedDrawer = new DOMParser()
//           .parseFromString(sections['cart-drawer'], 'text/html')
//           .querySelector('#CartDrawer');

//         if (parsedDrawer) {
//           drawerElement.innerHTML = parsedDrawer.innerHTML;
//         }
//       }

//       // Update header cart count.
//       if (sections['cart-icon-bubble']) {
//         const currentCartBubble = document.querySelector('#cart-icon-bubble');

//         const parsedBubble = new DOMParser()
//           .parseFromString(sections['cart-icon-bubble'], 'text/html')
//           .querySelector('#cart-icon-bubble');

//         if (currentCartBubble && parsedBubble) {
//           currentCartBubble.innerHTML = parsedBubble.innerHTML;
//         }
//       }

//       // Rebind the drawer overlay after replacing its HTML.
//       const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');

//       if (overlay) {
//         overlay.addEventListener('click', () => {
//           cartDrawer.close();
//         });
//       }

//       // Always reset drawer state before opening.
//       cartDrawer.classList.remove('active');

//       // Force browser to apply the closed state first.
//       void cartDrawer.offsetWidth;

//       requestAnimationFrame(() => {
//         cartDrawer.open(cartIcon);
//       });
//     } catch (error) {
//       console.error('XB cart drawer sync failed:', error);
//     }
//   }
// })();










// Integrates XB Sticky Add To Cart with Dawn's native cart-drawer.
//
// XB's button bypasses assets/product-form.js entirely, so Dawn never
// hears about its /cart/add call. We watch fetch only to detect that
// call — we do NOT reimplement Dawn's render/open logic by hand.
//
// IMPORTANT: assets/product-form.js (Dawn's own Main Add to Cart flow)
// also posts to /cart/add, and it always includes a `sections` param
// so it gets rendered sections back directly and calls
// cart-drawer's renderContents() itself. We use the presence of
// `sections` in the response as the signal that a request already
// went through Dawn's own pipeline, so we never double-handle it.
(() => {
  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const response = await originalFetch(...args);

    try {
      const request = args[0];
      const url = typeof request === 'string' ? request : request?.url || '';

      if (url.includes('/cart/add')) {
        const clonedResponse = response.clone();

        if (clonedResponse.ok) {
          const addResponse = await clonedResponse.json();

          // If the response already contains rendered sections, this
          // request came from Dawn's product-form.js, which already
          // calls cart-drawer.renderContents() itself. Do nothing, or
          // we'd race Dawn's own render/open pipeline.
          if (!addResponse.sections) {
            syncCartDrawer(addResponse);
          }
        }
      }
    } catch (error) {
      console.warn('XB cart sync:', error);
    }

    return response;
  };

  async function syncCartDrawer(addResponse) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    try {
      // Match Dawn's own product-form.js behavior so focus returns to
      // the right trigger and accessibility state stays consistent.
      cartDrawer.setActiveElement(document.activeElement);

      // Dawn's product-form.js clears "is-empty" in its own .finally()
      // block after a successful add. XB's flow bypasses product-form.js
      // entirely, so that class was staying stuck on the drawer whenever
      // the cart went from empty -> has items via XB. That stale class
      // made CSS keep hiding the freshly rendered contents (blank drawer)
      // and made open()'s focus-trap container lookup resolve incorrectly,
      // which is what threw "container is null" and broke the drawer's
      // open/close lifecycle afterward.
      if (cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner && drawerInner.classList.contains('is-empty')) {
        drawerInner.classList.remove('is-empty');
      }

      const sectionsResponse = await fetch(
        `${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`,
        { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
      );

      if (!sectionsResponse.ok) return;

      const sections = await sectionsResponse.json();

      // Let Dawn's own CartDrawer.renderContents() do the section
      // replacement, overlay rebind, and open() — the exact same path
      // Main Add to Cart uses. No manual innerHTML/classList hacks.
      cartDrawer.renderContents({
        id: addResponse.id,
        sections,
      });
    } catch (error) {
      console.error('XB cart drawer sync failed:', error);
    }
  }
})();